/* eslint-disable react/prop-types */
/* eslint-disable react-native/no-inline-styles */
/* eslint-disable react-native/no-color-literals */

import React, { useState, useEffect, useRef, useMemo } from 'react';
import { getDocumentAsync } from 'expo-document-picker';
import { useDispatch, useSelector } from 'react-redux';
import {
  View,
  StyleSheet,
  ScrollView,
  Dimensions,
  TouchableOpacity,
} from 'react-native';
import { Formik } from 'formik';
import * as Yup from 'yup';
import Toast from 'react-native-toast-message';
import * as Layout from '@components/screen/Layout';
import Colors from '@global/colors';
import { isWeb, isMobileWeb, isIos, isAndroid } from '@global/screens';
import {
  currency,
  uploadS3,
  randomString,
  convertTimeOfDate,
  isAllowedAttachmentFormat,
} from '@global/helpers';
import {
  ATTACHMENT_FORMAT_ERROR_TITLE,
  ATTACHMENT_FORMAT_ERROR_DESCRIPTION,
} from '@/constants';
import SociollaText from '@components/sociolla/SociollaText';
import Button from '@components/form/Button';
import ProgressBar from '@components/global/ProgressBar';
import ItemDetail from '@components/global/ItemDetail';
import Image from '@components/global/Image';
import Divider from '@components/global/Divider';
import Input from '@components/form/Input';
import CustomerSearch from '@components/form/search/CustomerReturnSearch';
import SourceDocument from '@components/form/search/SourceDocument';
import SalesTeamSearch from '@components/form/search/SalesTeamSearch';
import DatePicker from '@components/form/DatePicker';
import Alert from '@components/global/Alert';
import Discard from '@components/global/Discard';
import RemoveImage from '@/screens/sales-activity/components/todo-list/on-going/image/RemoveImage';

import useApi from '@/hooks/useApi';
import { MsOrder } from '@api/ms-order';
import { MsAccount } from '@api/ms-account';
import { showAlert, showDiscard, hideDiscard } from '@/store/global';
import { showPopup } from '@/store/modal';
import TimePicker from '@components/form/TimePicker';

const TitleSectionForm = ({
  title,
  showButton = true,
  buttonTitle,
  disabled = false,
  onCallback,
  buttonTitleChild = '',
  onCallbackChild = () => {},
}) => {
  return (
    <View
      style={{
        width: '100%',
        flexDirection: 'row',
        alignItems: 'center',
        justifyContent: 'space-between',
        backgroundColor: Colors.grey4,
        paddingHorizontal: 20,
        paddingVertical: 12,
      }}>
      <SociollaText
        type="bold"
        style={{
          fontSize: isWeb ? 16 : 13,
          letterSpacing: 0.5,
          color: Colors.grey1,
        }}>
        {title}
      </SociollaText>
      {showButton ? (
        <View
          style={{
            flexDirection: 'row',
            alignItems: 'center',
          }}>
          {buttonTitleChild ? (
            <Button
              type="default"
              rounded
              buttonStyle={{
                width: isWeb ? 150 : 85,
                marginRight: showButton ? 10 : 0,
              }}
              title={
                <SociollaText
                  type="bold"
                  style={{
                    fontSize: isWeb ? 14 : 13,
                    letterSpacing: 0.5,
                    color: Colors.black,
                  }}>
                  {buttonTitleChild}
                </SociollaText>
              }
              onPress={onCallbackChild}
            />
          ) : (
            false
          )}
          <Button
            type="default"
            rounded
            buttonStyle={{ width: isWeb ? 150 : 85 }}
            disabledStyle={{ width: isWeb ? 150 : 85 }}
            disabled={disabled}
            title={
              <SociollaText
                type="bold"
                style={{
                  fontSize: isWeb ? 14 : 13,
                  letterSpacing: 0.5,
                  color: Colors.black,
                }}>
                {buttonTitle}
              </SociollaText>
            }
            onPress={onCallback}
          />
        </View>
      ) : (
        false
      )}
    </View>
  );
};

const dimension = Dimensions.get('window');
const fullWidth = dimension.width;
const mobileWrapperWidth = fullWidth - 80;
const mobileWidth = fullWidth - 130;
const imageSize = 40;

const limit = 10;
const ReturnOrderFormScreen = (props) => {
  const formRef = useRef();
  const dispatch = useDispatch();
  const userData = useSelector((state) => state.auth.user);
  const menuPermission = useSelector((state) => state.auth.menuPermission);
  const userSalesTeam = userData?.sales_team || [];

  const totalPage = 2;
  const [isSubmit, setIsSubmit] = useState(false);
  const [bulkProductFile, setBulkProductFile] = useState(null);
  const [page, setPage] = useState(1);
  const [detailData, setDetailData] = useState({});
  const [selectedCustomer, setSelectedCustomer] = useState({});
  const [selectedSalesTeam, setSelectedSalesTeam] = useState({});
  const [isEdit, setIsEdit] = useState(false);
  const [isReady, setIsReady] = useState(false);
  const [isAvailableEdit, setIsAvailableEdit] = useState(false);
  const [loadingAddProduct, setLoadingAddProduct] = useState(false);
  const [products, setProducts] = useState([]);
  const [detailCustomerSales, setCustFromSales] = useState('');
  const [error, setError] = useState('');
  const [tambah, setTambah] = useState({
    status: false,
    rowKey: null,
  });
  const [subTotal, setSubTotal] = useState(0);
  const [taxes, setTaxes] = useState(0);
  const [total, setTotal] = useState(0);
  const [photo, setPhoto] = useState(null);
  const [skip, setSkip] = useState(0);

  const getSalesOrderDetail = useApi(MsOrder.getReturnOrderDetail);
  const getProductReturn = useApi(MsOrder.getProductSalesOrder);

  const getCustomers = useApi(MsAccount.getCustomerId);

  const isSales = useMemo(() => {
    return props?.route?.params?.isSales || '';
  }, [props.route.params]);
  const orderId = useMemo(() => {
    return props?.route?.params?.id || '';
  }, [props.route.params]);

  const activityId = useMemo(() => {
    return props?.route?.params?.activityId || '';
  }, [props.route.params]);

  const taskId = useMemo(() => {
    return props?.route?.params?.taskId || '';
  }, [props.route.params]);

  const isFromActivity = useMemo(() => {
    return Boolean(props?.route?.params?.customerActivityId || '');
  }, [props.route.params]);

  const orderIdSource = useMemo(() => {
    return props?.route?.params?.source || '';
  }, [props.route.params]);

  // get product for return order
  const selectProductReturn = async (id, cond) => {
    if (cond == true) {
      const response = await MsOrder.getProductReturnOrder(id, {
        params: {
          // filter: filter,
          skip: 0,
          limit: 10,
          sort: '-return_quantity -_id',
        },
      });
      if (response?.data?.data && Object.keys(response.data.data).length) {
        const ProdcutsData = response.data.data;
        setProducts(ProdcutsData);
      } else {
        setProducts({});
      }
      setTimeout(() => {
        setIsReady(true);
      }, 500);
    } else {
      if (isSales == true) {
        const IDOrder = props?.route?.params?.data?._id;
        const response = await getProductReturn.request(IDOrder);
        if (response?.data?.data && Object.keys(response.data.data).length) {
          const ProdcutsData = response.data.data;
          for (let i = 0; i < ProdcutsData?.length; i++) {
            ProdcutsData[i].return_quantity = 0;
          }
          setProducts(ProdcutsData);
        } else {
          setProducts({});
        }
        setTimeout(() => {
          setIsReady(true);
        }, 500);
      } else {
        const response = await getProductReturn.request(id);
        if (response?.data?.data && Object.keys(response.data.data).length) {
          const ProdcutsData = response.data.data;
          for (let i = 0; i < ProdcutsData?.length; i++) {
            ProdcutsData[i].return_quantity = 0;
          }
          setProducts(ProdcutsData);
        } else {
          setProducts({});
        }
        setTimeout(() => {
          setIsReady(true);
        }, 500);
      }
    }
  };

  const getCustomer = async () => {
    if (!isSales) {
      setCustFromSales('');
    } else {
      const customerId = props?.route?.params?.data?.customer?.id;
      const response = await getCustomers.request(customerId);
      setCustFromSales(response?.data?.data || '');
    }
  };

  const calculateTotal = (r) => {
    let sub_total = 0;
    let total_tax = 0;
    let total_price = 0;

    let price = 0;
    let qty = 0;
    let totalPrice = 0;
    let product_tax = 0;
    let tax = 0;
    let default_tax = 0;
    let unit_price = 0;
    let product_amount_real = 0;

    const arrTotalPrice = [];
    const arrTotalTaxes = [];
    const arrTotalAmountReal = [];
    const prod = products;

    if (isEdit) {
      for (let i = 0; i < products.length; i++) {
        default_tax = products[i].taxes?.percentage;
        unit_price = products[i]?.unit_price;

        price = Number(
          products[i].total_price_before_tax / products[i].quantity,
        );
        qty = Number(products[i].return_quantity);

        totalPrice = price * qty;
        arrTotalPrice.push(totalPrice);

        if (prod[i].taxes.type == 'inc') {
          const min_tax = 1 + default_tax / 100;
          tax = unit_price / min_tax;
          product_tax = unit_price - tax;
          product_amount_real = unit_price * qty;
          arrTotalTaxes.push(product_tax * qty);
          arrTotalAmountReal.push(product_amount_real);
        } else {
          const min_tax = default_tax / 100;
          product_tax = unit_price * qty * min_tax;
          product_amount_real = (unit_price + unit_price * min_tax) * qty;
          arrTotalTaxes.push(product_tax);
          arrTotalAmountReal.push(product_amount_real);
        }

        sub_total += arrTotalPrice[i];
        total_tax += arrTotalTaxes[i];
        total_price += arrTotalPrice[i] + arrTotalTaxes[i];
      }

      setSubTotal(Math.round(sub_total));
      setTaxes(Math.round(total_tax));
      setTotal(Math.round(total_price));
    } else {
      for (let i = 0; i < products.length; i++) {
        default_tax = products[i].taxes?.percentage;
        unit_price = products[i]?.unit_price;

        price = Number(
          products[i].total_price_before_tax / products[i].quantity,
        );
        qty = Number(products[i].return_quantity);

        totalPrice = price * qty;
        arrTotalPrice.push(totalPrice);

        if (prod[i].taxes.type === 'inc') {
          const min_tax = 1 + default_tax / 100;
          tax = unit_price / min_tax;
          product_tax = unit_price - tax;
          product_amount_real = unit_price * qty;

          arrTotalTaxes.push(product_tax * qty);
          arrTotalAmountReal.push(product_amount_real);
        } else {
          const min_tax = default_tax / 100;
          product_tax = unit_price * qty * min_tax;
          product_amount_real = (unit_price + unit_price * min_tax) * qty;
          arrTotalTaxes.push(product_tax);
          arrTotalAmountReal.push(product_amount_real);
        }

        sub_total += arrTotalPrice[i];
        total_tax += arrTotalTaxes[i];
        total_price += arrTotalPrice[i] + arrTotalTaxes[i];
      }
      setSubTotal(Math.round(sub_total));
      setTaxes(Math.round(total_tax));
      setTotal(Math.round(total_price));
    }
  };

  const getProductSalesOrder = async (id, newSkip = 0, isNewOrder = false) => {
    setSkip(newSkip);
    const isMore = newSkip > 0;
    let response;
    if (!isNewOrder) {
      response = await MsOrder.getProductReturnOrder(id, {
        params: {
          skip: newSkip,
          limit: limit,
          sort: '-return_quantity -_id',
        },
      });
    } else {
      response = await MsOrder.getProductSalesOrder(id, {
        params: {
          skip: newSkip,
          limit: limit,
        },
      });
    }

    if (response?.data?.data?.length) {
      const result = response.data.data;
      let finalResult = JSON.parse(JSON.stringify(products));
      if (isMore) {
        const arr = [];
        const tempFinal = finalResult.concat(result);
        for (let i = 0; i < tempFinal.length; i++) {
          const item = tempFinal[i];
          if (isNewOrder && !item.return_quantity) {
            item.return_quantity = 0;
          }
          if (
            !arr.find(
              (a) =>
                a?.id == item?.id &&
                a?.combination?.id == item?.combination?.id,
            )
          ) {
            arr.push(item);
          }
        }
        finalResult = arr;
      } else {
        finalResult = result;
      }
      calculateTotal(finalResult);
      setProducts(finalResult);
      if (!isMore && !isWeb && props?.route?.params?.firstAdded) {
        setPage(2);
      }
    } else {
      if (!isMore) {
        setProducts([]);
      }
    }
  };

  const getDetail = async (id) => {
    const response = await getSalesOrderDetail.request(id);
    if (response?.data?.data && Object.keys(response.data.data).length) {
      const result = response.data.data;
      setDetailData(result);
      setPhoto(result?.upload_return_form);
      getProductSalesOrder(id);
    } else {
      setDetailData({});
    }
    setTimeout(() => {
      setIsReady(true);
    }, 500);
  };

  const resetData = () => {
    setSkip(0);
    setIsSubmit(false);
    setBulkProductFile(null);
    setIsReady(false);
    setIsAvailableEdit(false);
    setIsEdit(false);
    setLoadingAddProduct(false);
    setPage(1);
    setSubTotal(0);
    setTaxes(0);
    setTotal(0);
    setProducts([]);
    setDetailData({});
    setSelectedCustomer({});
    setSelectedSalesTeam({});
    setPhoto(null);
  };

  const goToActivity = () => {
    props.navigation.navigate('ReturnOrderNavigator', {
      screen: 'ReturnOrderScreen',
      params: {
        id: activityId,
        direct: 'orders',
      },
    });
  };

  // handle back button
  const goBack = () => {
    if (isSales) {
      props.navigation.navigate('SalesOrderDetailScreen', props.route.params);
    } else if (isEdit) {
      props.navigation.navigate('ReturnOrderDetailScreen', props.route.params);
    } else if (activityId && taskId) {
      goToActivity();
    } else {
      props.navigation.navigate('ReturnOrderScreen');
    }
  };

  // show discard popup when click back button
  const needToBack = (e = null) => {
    const btnStyle = {
      width: isWeb ? 100 : 220,
      marginHorizontal: isWeb ? 5 : 0,
      marginBottom: 10,
    };
    dispatch(
      showDiscard({
        show: true,
        title: 'Discard',
        description: 'Unsaved data will be deleted. Do you want to proceed?',
        buttons: [
          {
            type: 'main',
            style: btnStyle,
            textColor: Colors.white,
            text: 'OK',
            callback: () => {
              if (
                !isWeb &&
                props?.route?.params?.firstAdded &&
                detailData?._id
              ) {
                props.navigation.replace('ReturnOrderFormScreen', {
                  titleScreen: detailData.reference_code,
                  name: detailData.name,
                  id: detailData._id,
                });
              }
              if (e?.data?.action) {
                props.navigation.dispatch(e.data.action);
              } else {
                goBack();
              }
              dispatch(hideDiscard());
            },
          },
          {
            type: 'default',
            style: btnStyle,
            textColor: Colors.black,
            text: 'Save Draft',
            callback: () => {
              dispatch(hideDiscard());
              if (formRef.current) {
                formRef.current.handleSubmit();
              }
            },
          },
          {
            type: 'default',
            style: btnStyle,
            textColor: Colors.black,
            text: 'Cancel',
            callback: () => dispatch(hideDiscard()),
          },
        ],
      }),
    );
  };

  // change left button
  useEffect(() => {
    props.navigation.setOptions({
      headerLeft: () => <Layout.BackCustom onCallback={() => goToActivity()} />,
    });
  }, [props]);

  // detect route change
  useEffect(() => {
    props.navigation.addListener('beforeRemove', (e) => {
      if (!isSubmit && isReady) {
        needToBack(e);
      }
    });
    return () => {
      props.navigation.removeListener('beforeRemove');
    };
  }, [props.navigation, isSubmit]);

  useEffect(() => {
    let mounted = true;
    if (mounted) {
      if (isSales) {
        getCustomer();
      }
      if (!menuPermission.find((permit) => permit == 'OrderCreate')) {
        Toast.show({
          text1: 'You have no permission for this page',
          type: 'error',
        });
        setTimeout(() => {
          props.navigation.navigate('HomeNavigator', {
            screen: 'HomeScreen',
          });
        }, 500);
      } else {
        if (!bulkProductFile) {
          resetData();
        }
        if (orderId) {
          if (isSales == true) {
            setIsEdit(false);
            setTambah({
              status: false,
            });
            const IDOrder = props?.route?.params?.data?._id;
            selectProductReturn(IDOrder);
          } else {
            setIsEdit(true);
            setTambah({
              status: true,
              rowKey: orderIdSource,
            });
            getDetail(orderId);
            selectProductReturn(orderId, true);
          }
        } else {
          setIsEdit(false);
          // setTambah(false)
          setTambah({
            status: false,
            rowKey: null,
          });

          setTimeout(() => {
            setIsReady(true);
            if (props?.route?.params?.customerActivityId) {
              getDetailCustomer(props.route.params.customerActivityId);
            }
          }, 500);
        }
      }
    }

    return () => {
      mounted = false;
    };
  }, [props]);

  const handleSave = () => {
    const ProdcutsData = products;
    if (isEdit) {
      const ProductMap = ProdcutsData.map(({ parent_id, return_quantity }) => {
        return {
          parent_id: parent_id,
          return_quantity: return_quantity,
        };
      });
      return ProductMap;
    } else {
      const ProductMap = ProdcutsData.map(({ _id, return_quantity }) => {
        return {
          parent_id: _id,
          return_quantity: return_quantity,
        };
      });
      return ProductMap;
    }
  };

  const hideRow = (id) => {
    setTambah({
      status: true,
      rowKey: id,
    });
  };

  // form validation for Return order
  const FormValidationSchema = Yup.object().shape({
    customer: Yup.object().required('Customer is required.'),
    // reference_code: Yup.object().required('Source Document is required.'),
    sales_team: Yup.object().required('Sales Team is required.'),
    // special_expired_period: Yup.string().required(
    //   'Spesial Expired is required.',
    // ),

    time_at: Yup.string().required('Time is required.'),
    // upload_return_form: Yup.string().required('Attachment is required.'),
    scheduled_date: Yup.string()
      .required('Scheduled date is required.')
      .when('status', (status) => {
        if (status != 'draft') {
          return Yup.string().required('Scheduled date is required.');
        }
        return Yup.string();
      }),
  });

  const getDetailCustomer = async (customerId) => {
    const response = await getCustomers.request(customerId);
    const customer = response?.data?.data;
    if (customer?.id) {
      setSelectedCustomer({
        id: customer?.id,
        name: customer?.name,
      });

      if (isFromActivity && formRef.current) {
        formRef.current.setFieldValue('customer', customer);
        if (
          customer?.market_type?.code?.toLowerCase() == 'gt' &&
          customer?.user?.id
        ) {
          formRef.current.setFieldValue('sales_person', customer?.user);
        }
      }
    }
  };

  const backTitle = useMemo(() => {
    if (activityId && taskId) {
      return 'Order Activity';
    }
    if (isEdit) {
      return props.route.params.name;
    }
    if (isSales) {
      return 'Sales Order';
    }
    return 'Return Order';
  }, [activityId, taskId, isEdit, isSales]);

  useEffect(() => {
    let mounted = true;
    if (mounted && isReady && isEdit && detailData) {
      if (detailData?.price_list?.id) {
        formRef.current.setFieldValue('pricelist', {
          id: detailData.price_list.id,
          name: detailData?.price_list?.name,
        });
      }

      if (detailData.customer && Object.keys(detailData.customer).length) {
        getDetailCustomer(detailData?.customer?.id);
      }
      setTimeout(() => {
        setIsAvailableEdit(true);
      }, 500);
    }
    return () => {
      mounted = false;
    };
  }, [isReady, isEdit, detailData]);

  useEffect(() => {
    let mounted = true;
    if (mounted && selectedCustomer?.id && selectedSalesTeam?.id) {
      getProductSalesOrder();
    }
    return () => {
      mounted = false;
    };
  }, [selectedCustomer, selectedSalesTeam]);

  const isLoadingPage =
    (isEdit
      ? getSalesOrderDetail.loading ||
        !(detailData && Object.keys(detailData).keys.length)
      : true) && !isReady;

  return (
    <Layout.Container>
      {!isWeb && <ProgressBar page={page} totalPage={totalPage} />}
      {isLoadingPage ? (
        <Layout.Wrapper rounded>
          <Layout.Loader />
        </Layout.Wrapper>
      ) : (
        <Formik
          innerRef={formRef}
          initialValues={{
            customer:
              isEdit &&
              detailData?.customer &&
              Object.keys(detailData.customer).length
                ? detailData.customer
                : isSales && detailCustomerSales,
            source_order:
              isEdit &&
              detailData?.source_order &&
              Object.keys(detailData.source_order).length
                ? detailData?.source_order
                : isSales && props?.route?.params?.titleScreen,
            // Temporary command
            // reference_code: isEdit
            // ? detailData?.source_order && Object.keys(detailData.customer).length
            //   ? {
            //       reference_code: detailData?.source_order?.reference_code,
            //     }
            //   : ''
            // : '',

            // customer:
            //   isEdit &&
            //   detailData?.customer &&
            //   Object.keys(detailData.customer).length
            //     ? detailData.customer
            //     : '',
            scheduled_date:
              isEdit &&
              detailData?.scheduled_date &&
              Object.keys(detailData.scheduled_date).length
                ? detailData.scheduled_date
                : isSales && new Date().toDateString(),
            time_at:
              isEdit &&
              detailData?.scheduled_time &&
              convertTimeOfDate(detailData?.scheduled_time) &&
              Object.keys(detailData.scheduled_time).length
                ? detailData.scheduled_time
                : isSales &&
                  new Date().getHours() + ':' + new Date().getMinutes(),

            sales_team:
              isEdit &&
              detailData?.sales_team &&
              Object.keys(detailData.sales_team).length
                ? detailData.sales_team
                : isSales && detailCustomerSales.sales_team,

            // special_expired_period:
            //   isEdit &&
            //   detailData?.customer?.special_expired_period &&
            //   Object.keys(detailData.customer?.special_expired_period).length
            //     ? detailData.customer?.special_expired_period
            //     : isSales && detailCustomerSales.special_expired_period,

            status: isEdit && detailData?.status ? detailData.status : 'draft',
            upload_return_form:
              isEdit &&
              (detailData?.upload_return_form?.length ||
                Object.keys(detailData?.upload_return_form || {}).length > 0)
                ? detailData?.upload_return_form
                : [],

            // attachment:
            //   isEdit &&
            //   detailData?.upload_return_form &&
            //   Object.keys(detailData.upload_return_form).length
            //     ? detailData.attachment
            //     : '',
          }}
          validationSchema={FormValidationSchema}
          onSubmit={async (values) => {
            setIsSubmit(true);
            dispatch(showPopup({ name: 'isLoading', value: true }));

            if (values?.customer?.id == '') {
              setIsSubmit(false);
              dispatch(showPopup({ name: 'isLoading', value: false }));
              Toast.show({
                text1: 'Customer ID is Empty.',
                type: 'error',
              });
            } else {
              const alert_title =
                values.status == 'draft'
                  ? 'Return Order Saved'
                  : 'Return Order Submitted';
              const alert_description =
                values.status == 'draft'
                  ? 'Return order saved as a draft'
                  : 'Return order submitted and need confirmation';

              const payload = {
                scheduled_date: new Date(values.scheduled_date).toISOString(),
                scheduled_time: values.time_at,
                products: values.products,
              };

              if (isSales == true) {
                payload.source_order = props?.route?.params?.titleScreen
                  ? {
                      id: props?.route?.params?.id,
                      reference_code: props?.route?.params?.titleScreen,
                    }
                  : {
                      id: values.source_order.id,
                      reference_code: values?.source_order?.reference_code,
                    };

                payload.customer_id = detailCustomerSales._id
                  ? detailCustomerSales._id
                  : values?.customer?.id;
              } else {
                payload.customer_id = values?.customer?.id;
                payload.source_order = {
                  id: values.source_order.id,
                  reference_code: values?.source_order?.reference_code,
                };
              }
              if (!isEdit) {
                const attach_ = values?.upload_return_form;
                attach_.map(function (img, idx) {
                  payload.upload_return_form = img ? img : {};
                });
              }
              if (activityId && taskId) {
                payload.activity = {
                  id: activityId,
                  task_id: taskId,
                };
              }

              try {
                if (isEdit) {
                  if (photo === null) {
                    setError('Attachment is required');
                    dispatch(showPopup({ name: 'isLoading', value: false }));
                  } else {
                    const updateData = await MsOrder.updateReturnOrder(
                      detailData._id,
                      payload,
                    );
                    if (updateData && updateData.data && updateData.data.data) {
                      dispatch(showPopup({ name: 'isLoading', value: false }));
                      dispatch(
                        showAlert({
                          show: true,
                          title: alert_title,
                          description: alert_description,
                          isConfirm: false,
                          onCallback: () => {
                            global.isFromAdded = true;
                            if (isEdit) {
                              props.navigation.navigate(
                                'ReturnOrderDetailScreen',
                                props.route.params,
                              );
                            } else {
                              props.navigation.navigate('ReturnOrderScreen', {
                                titleScreen: detailData.reference_code,
                                name: detailData.name,
                                id: detailData._id,
                                ...(activityId && taskId
                                  ? {
                                      activityId: activityId,
                                      taskId: taskId,
                                    }
                                  : {}),
                              });
                            }
                          },
                        }),
                      );
                    } else {
                      setIsSubmit(false);
                      dispatch(showPopup({ name: 'isLoading', value: false }));
                      Toast.show({
                        text1: 'A system error occurred',
                        type: 'error',
                      });
                    }
                  }
                } else {
                  if (values?.upload_return_form.length == 0) {
                    setError('Attachment is required');
                    dispatch(showPopup({ name: 'isLoading', value: false }));
                  } else {
                    const createData = await MsOrder.createReturnOrder(payload);
                    if (createData && createData.data && createData.data.data) {
                      const result = createData.data.data;
                      dispatch(showPopup({ name: 'isLoading', value: false }));
                      if (!isEdit && products?.length > 1) {
                        if (result._id) {
                          global.isFromAdded = true;
                          dispatch(
                            showAlert({
                              show: true,
                              title: alert_title,
                              description: alert_description,
                              hideCancel: true,
                              onCallback: () => {
                                global.isFromAdded = true;
                                if (result._id) {
                                  props.navigation.navigate(
                                    'ReturnOrderDetailScreen',
                                    {
                                      id: result._id,
                                      titleScreen: result.reference_code,
                                      name: result.name,

                                      ...(activityId && taskId
                                        ? {
                                            activityId: activityId,
                                            taskId: taskId,
                                          }
                                        : {}),
                                    },
                                  );
                                } else {
                                  props.navigation.navigate(
                                    'ReturnOrderScreen',
                                  );
                                }
                              },
                            }),
                          );
                        }
                      } else {
                        dispatch(
                          showAlert({
                            show: true,
                            title: alert_title,
                            description: alert_description,
                            hideCancel: true,
                            onCallback: () => {
                              global.isFromAdded = true;
                              if (result._id) {
                                props.navigation.navigate(
                                  'ReturnOrderDetailScreen',
                                  {
                                    id: result._id,
                                    titleScreen: result.reference_code,
                                    name: result.name,

                                    ...(activityId && taskId
                                      ? {
                                          activityId: activityId,
                                          taskId: taskId,
                                        }
                                      : {}),
                                  },
                                );
                              } else {
                                props.navigation.navigate('ReturnOrderScreen');
                              }
                            },
                          }),
                        );
                      }
                    } else {
                      setIsSubmit(false);
                      dispatch(showPopup({ name: 'isLoading', value: false }));
                      Toast.show({
                        text1: 'A system error occurred',
                        type: 'error',
                      });
                    }
                  }
                }
              } catch (error) {
                setIsSubmit(false);
                dispatch(showPopup({ name: 'isLoading', value: false }));
                const errorMessage =
                  error?.response?.data?.message || 'A system error occurred';
                if (
                  error?.response?.data?.errorCode == 'BAD_REQUEST' &&
                  error?.response?.data?.message &&
                  error?.response?.data?.message.indexOf('overlimit') > -1 &&
                  formRef.current
                ) {
                  formRef.current.setErrors({
                    customer: error.response.data.message,
                  });
                  if (!isWeb) {
                    dispatch(
                      showAlert({
                        show: true,
                        title: 'Error',
                        description: errorMessage,
                        isConfirm: false,
                      }),
                    );
                    setPage(1);
                  }
                } else {
                  dispatch(
                    showAlert({
                      show: true,
                      title: 'Error',
                      description: errorMessage,
                      isConfirm: false,
                    }),
                  );
                }
              }
            }
          }}>
          {({
            setFieldValue,
            validateForm,
            handleSubmit,
            errors,
            touched,
            values,
          }) => (
            <>
              {isWeb ? (
                <Layout.Wrapper white={false}>
                  <Layout.Back
                    title={backTitle}
                    onCallback={() => needToBack()}
                  />
                  <Layout.Title
                    title={isEdit ? 'Edit Return Order' : 'Add Return Order'}>
                    {isEdit ? (
                      <Button
                        rounded
                        buttonStyle={{ width: 120 }}
                        disabledStyle={{ width: 120 }}
                        disabled={!isAvailableEdit}
                        title={
                          <SociollaText
                            type="bold"
                            style={{
                              fontSize: 14,
                              letterSpacing: 0.5,
                              color: Colors.white,
                            }}>
                            {isAvailableEdit ? 'SAVE' : 'LOADING'}
                          </SociollaText>
                        }
                        onPress={(evt) => {
                          evt.persist();
                          setFieldValue('status', 'draft');
                          setFieldValue('products', handleSave());

                          setTimeout(() => {
                            validateForm().then((validate) => {
                              handleSubmit(evt);
                              if (validate && Object.keys(validate).length) {
                                setPage(1);
                              }
                            });
                          }, 100);
                        }}
                      />
                    ) : (
                      <View
                        style={{
                          width: 300,
                          flexDirection: 'row',
                          alignItems: 'center',
                          justifyContent: 'flex-end',
                        }}>
                        <Button
                          type="primary"
                          rounded
                          buttonStyle={{ width: 105, marginRight: 10 }}
                          title={
                            <SociollaText
                              type="bold"
                              style={{
                                fontSize: 14,
                                letterSpacing: 0.5,
                                color: Colors.white,
                              }}>
                              Save Draft
                            </SociollaText>
                          }
                          onPress={(evt) => {
                            evt.persist();
                            setFieldValue('status', 'draft');
                            setFieldValue('products', handleSave());

                            setTimeout(() => {
                              validateForm().then((validate) => {
                                handleSubmit(evt);
                                if (validate && Object.keys(validate).length) {
                                  setPage(1);
                                }
                              });
                            }, 100);
                          }}
                        />
                        {/* temporary command not used now */}
                        {/* <Button
                          rounded
                          buttonStyle={{ width: 185 }}
                          disabledStyle={{ width: 185 }}
                          disabled={!isAvailableSubmit(values)}
                          title={
                            <SociollaText
                              type="bold"
                              style={{
                                fontSize: 14,
                                letterSpacing: 0.5,
                                color: Colors.white,
                              }}>
                              Request Confirmation
                            </SociollaText>
                          }
                          onPress={(evt) => {
                            evt.persist();
                            if (!isEdit) {
                              onChangeFilter();
                            }
                            setFieldValue('status', 'need_approval');
                            setTimeout(() => {
                              validateForm().then((validate) => {
                                handleSubmit(evt);
                                if (validate && Object.keys(validate).length) {
                                  setPage(1);
                                }
                              });
                            }, 100);
                          }}
                        /> */}
                      </View>
                    )}
                  </Layout.Title>
                </Layout.Wrapper>
              ) : (
                false
              )}
              <Layout.Wrapper rounded hasProgressBar>
                <ScrollView
                  style={isMobileWeb ? { height: dimension.height - 55 } : {}}
                  contentContainerStyle={{ width: '100%' }}>
                  {page == 1 || isWeb ? (
                    <Layout.FormWrapper
                      style={{
                        paddingHorizontal: isWeb ? 20 : 15,
                        ...(isWeb
                          ? { paddingVertical: 20 }
                          : {
                              paddingBottom: !isMobileWeb
                                ? isAndroid
                                  ? 150
                                  : 80
                                : 100,
                            }),
                      }}>
                      <View
                        style={{
                          width: isWeb ? 'calc(50% - 30px)' : '100%',
                          marginRight: isWeb ? 30 : 0,
                        }}>
                        <Layout.FormGroup>
                          <CustomerSearch
                            fields="_id name market_type user sales_team"
                            value={values.customer}
                            isRequired={true}
                            hasError={
                              errors.customer && touched.customer
                                ? errors.customer
                                : null
                            }
                            customFilter={{
                              status: 'approved',
                              keyword: {},
                            }}
                            editable={!props?.route?.params?.customerActivityId}
                            onChange={(value) => {
                              setFieldValue('customer', value);
                              setFieldValue('customer_id', value.id);
                              // setFieldValue(
                              //   'special_expired_period',
                              //   value.special_expired_period,
                              // );
                              setFieldValue(
                                'scheduled_date',
                                new Date().toDateString(),
                              );
                              const today = new Date();
                              const hourInitial = today.getHours();
                              const hourDefault =
                                hourInitial.toString().length == 1
                                  ? `0${hourInitial}`
                                  : hourInitial;
                              const minuteInitial = Math.min(
                                today.getMinutes(),
                                59,
                              );
                              const minuteDefault =
                                minuteInitial.toString().length == 1
                                  ? `0${minuteInitial}`
                                  : minuteInitial;
                              const now_time = `${hourDefault}:${minuteDefault}`;
                              setFieldValue('time_at', now_time);
                              if (products?.length) {
                                setProducts([]);
                              }
                              if (value) {
                                if (
                                  value?.market_type?.code?.toLowerCase() ==
                                  'mt'
                                ) {
                                  // auto fill sales team based on customer sales team
                                  if (
                                    value?.sales_team &&
                                    Object.keys(value.sales_team).length
                                  ) {
                                    const selectedST = value.sales_team;
                                    if (selectedST?.id) {
                                      setSelectedSalesTeam(selectedST);
                                    }
                                    setFieldValue('sales_team', selectedST);
                                  } else {
                                    setSelectedSalesTeam({});
                                    setFieldValue('sales_team', {});
                                  }
                                } else {
                                  // auto fill sales person and branch code based on customer user
                                  if (
                                    value.user &&
                                    Object.keys(value.user).length
                                  ) {
                                    setFieldValue('sales_person', value.user);
                                  } else {
                                    setFieldValue('sales_person', {});
                                  }

                                  // auto fill sales team based on customer sales team
                                  if (
                                    value.sales_team &&
                                    Object.keys(value.sales_team).length
                                  ) {
                                    if (value.sales_team?.id) {
                                      setSelectedSalesTeam(value.sales_team);
                                    }
                                    setFieldValue(
                                      'sales_team',
                                      value.sales_team,
                                    );
                                  } else {
                                    setSelectedSalesTeam({});
                                    setFieldValue('sales_team', {});
                                    setFieldValue('sales_person', {});
                                  }
                                }
                              }
                            }}
                          />
                        </Layout.FormGroup>

                        <Layout.FormGroup>
                          <SourceDocument
                            value={values.source_order}
                            customerId={
                              values.customer_id && values.customer_id
                                ? values.customer_id
                                : ''
                            }
                            customFilter={{
                              status: 'approved',
                              'customer.id': isEdit
                                ? values.customer.id
                                : values.customer_id,
                            }}
                            keywordFor="order_number"
                            isRequired={true}
                            orderIdCustomer={values._id}
                            onChange={(value) => {
                              selectProductReturn(value._id);
                              setFieldValue('source_order', value);
                              setFieldValue(
                                'reference_code',
                                value.reference_code,
                              );
                            }}
                          />
                        </Layout.FormGroup>

                        <Layout.FormGroup>
                          {selectedCustomer?.market_type?.code?.toLowerCase() ==
                          'mt' ? (
                            <>
                              {userSalesTeam?.length ? (
                                <Input
                                  label="Sales Team"
                                  value={
                                    values.sales_team && values.sales_team.id
                                      ? values.sales_team.name
                                      : ''
                                  }
                                  isRequired
                                  editable={false}
                                  hasError={
                                    errors.sales_team && touched.sales_team
                                      ? errors.sales_team
                                      : null
                                  }
                                />
                              ) : (
                                <SalesTeamSearch
                                  value={
                                    values.sales_team && values.sales_team.id
                                      ? values.sales_team
                                      : ''
                                  }
                                  hasError={
                                    errors.sales_team && touched.sales_team
                                      ? errors.sales_team
                                      : null
                                  }
                                  onChange={(value) => {
                                    setSelectedSalesTeam(value);
                                    setFieldValue('sales_team', value);
                                    setFieldValue('sales_person', {});
                                  }}
                                />
                              )}
                            </>
                          ) : (
                            <Input
                              label="Sales Team"
                              value={
                                values.sales_team && values.sales_team.id
                                  ? values.sales_team.name
                                  : ''
                              }
                              isRequired
                              editable={false}
                              hasError={
                                errors.sales_team && touched.sales_team
                                  ? errors.sales_team
                                  : null
                              }
                            />
                          )}
                        </Layout.FormGroup>
                        {/* <Layout.FormGroup>
                          <Input
                            label="Spesial Expired Date"
                            value={
                              values.special_expired_period &&
                              values.special_expired_period
                                ? values.special_expired_period
                                : ''
                            }
                            isRequired
                            editable={false}
                            hasError={
                              errors.special_expired_period &&
                              touched.special_expired_period
                                ? errors.special_expired_period
                                : null
                            }
                          />
                        </Layout.FormGroup> */}
                      </View>
                      <View
                        style={{
                          width: isWeb ? 'calc(50% - 30px)' : '100%',
                          marginRight: isWeb ? 30 : 0,
                        }}>
                        <Layout.FormGroup>
                          <DatePicker
                            label="Scheduled  Date"
                            name="created_at"
                            value={values.scheduled_date}
                            disablePastDates={true}
                            isRequired={true}
                            hasError={
                              errors.scheduled_date && touched.scheduled_date
                                ? errors.scheduled_date
                                : null
                            }
                            onChange={(value) => {
                              const newDate = new Date(value);
                              if (newDate > new Date(values.created_at)) {
                                setFieldValue(
                                  'created_at',
                                  new Date(
                                    newDate.getFullYear(),
                                    newDate.getMonth(),
                                    newDate.getDate() + 2,
                                  ).toDateString(),
                                );
                              }
                              if (
                                newDate > new Date(values.delivered_at) ||
                                !values.delivered_at
                              ) {
                                setFieldValue(
                                  'delivered_at',
                                  new Date(
                                    newDate.getFullYear(),
                                    newDate.getMonth(),
                                    newDate.getDate() + 1,
                                  ).toDateString(),
                                );
                              }
                              setFieldValue(
                                'scheduled_date',
                                new Date(value).toDateString(),
                              );
                              // new Date(value).toDateString(),
                              // setFieldValue('time_at',  convertTimeOfDate( newDate.toDateString(),))
                            }}
                          />
                          <TimePicker
                            label="Scheduled Time"
                            value={values.time_at}
                            isRequired
                            hasError={
                              errors.time_at && touched.time_at
                                ? errors.time_at
                                : null
                            }
                            onChange={(value) =>
                              setFieldValue('time_at', value)
                            }
                          />
                        </Layout.FormGroup>
                        <Layout.FormGroup>
                          <SociollaText
                            type="bold"
                            style={{
                              fontSize: isWeb ? 10 : 9,
                              color: Colors.grey1,
                            }}>
                            Upload Return Form
                          </SociollaText>

                          <View style={styles.documentWrapper}>
                            <View
                              style={[
                                styles.attachment,
                                { justifyContent: 'flex-start' },
                              ]}>
                              <TouchableOpacity
                                isRequired
                                activeOpacity={0.8}
                                style={styles.attachmentItem}
                                onPress={async () => {
                                  const attach = await getDocumentAsync({
                                    copyToCacheDirectory: false,
                                  });
                                  if (!attach.canceled) {
                                    if (
                                      !isAllowedAttachmentFormat(
                                        attach.assets[0],
                                      )
                                    ) {
                                      dispatch(
                                        showAlert({
                                          show: true,
                                          title: ATTACHMENT_FORMAT_ERROR_TITLE,
                                          description:
                                            ATTACHMENT_FORMAT_ERROR_DESCRIPTION,
                                          isConfirm: false,
                                        }),
                                      );
                                      return;
                                    }
                                    dispatch(
                                      showPopup({
                                        name: 'isLoading',
                                        value: true,
                                      }),
                                    );
                                    try {
                                      const url = await uploadS3({
                                        file: attach.assets[0] || {},
                                        isNeedMobileSupport: true,
                                      });
                                      if (url) {
                                        const newFile = {
                                          name: `SO-${randomString(5)}`,
                                          url: url,
                                        };
                                        let initiateFiles = [];
                                        if (
                                          values.upload_return_form === null
                                        ) {
                                          setFieldValue(
                                            'upload_return_form',
                                            [],
                                          );
                                        } else {
                                          const files = JSON.parse(
                                            JSON.stringify(
                                              values.upload_return_form,
                                            ),
                                          );
                                          initiateFiles = files;
                                        }
                                        initiateFiles.push(newFile);
                                        if (newFile?.url && isEdit) {
                                          const payload = {
                                            upload_return_form: newFile,
                                          };
                                          const attachResponse =
                                            await MsOrder.createAttachmentReturn(
                                              detailData?._id,
                                              payload,
                                            );
                                          if (
                                            attachResponse?.data?.data
                                              ?.upload_return_form
                                          ) {
                                            setDetailData((prev) => ({
                                              ...prev,
                                              upload_return_form: newFile,
                                            }));
                                            setPhoto(newFile);
                                            setFieldValue(
                                              'upload_return_form',
                                              newFile,
                                            );
                                          }
                                        } else {
                                          setDetailData((prev) => ({
                                            ...prev,
                                            upload_return_form: newFile,
                                          }));
                                          setPhoto(newFile);
                                          setFieldValue(
                                            'upload_return_form',
                                            newFile,
                                          );
                                          setFieldValue(
                                            'upload_return_form',
                                            initiateFiles,
                                          );
                                        }
                                        if (error) {
                                          setError('');
                                        }
                                      } else {
                                        Toast.show({
                                          text1:
                                            'Failed to upload file. Please try again.',
                                          type: 'error',
                                        });
                                      }
                                      dispatch(
                                        showPopup({
                                          name: 'isLoading',
                                          value: false,
                                        }),
                                      );
                                    } catch (err) {
                                      Toast.show({
                                        text1: 'A system error occurred',
                                        type: 'error',
                                      });
                                      dispatch(
                                        showPopup({
                                          name: 'isLoading',
                                          value: false,
                                        }),
                                      );
                                    }
                                  }
                                }}>
                                {photo === null ? (
                                  <View></View>
                                ) : (
                                  <RemoveImage
                                    data={values.upload_return_form}
                                    conpywriting={{
                                      title: 'Remove Attachment',
                                      description:
                                        'Are you sure you want to remove this file?',
                                    }}
                                    setData={async (val) => {
                                      if (isEdit) {
                                        const removeItem =
                                          detailData?.upload_return_form;
                                        await MsOrder.removeAttachmentReturn(
                                          detailData?._id,
                                          removeItem?._id,
                                        );
                                        setDetailData((prev) => ({
                                          ...prev,
                                          upload_return_form: null,
                                        }));
                                        setPhoto(null);
                                        setFieldValue(
                                          'upload_return_form',
                                          null,
                                        );
                                      } else {
                                        setDetailData((prev) => ({
                                          ...prev,
                                          upload_return_form: null,
                                        }));
                                        setPhoto(null);
                                        setFieldValue(
                                          'upload_return_form',
                                          null,
                                        );
                                      }
                                    }}
                                  />
                                )}

                                {photo === null ? (
                                  <Image
                                    style={[
                                      styles.attachmentIcon,
                                      { width: 50, height: 50 },
                                    ]}
                                    width={40}
                                    height={40}
                                    isResolveAsset
                                    source={require('@assets/img/icons/menu/create-sales-order.svg')}
                                  />
                                ) : (
                                  <View>
                                    <Image
                                      style={[
                                        styles.attachmentIcon,
                                        { width: 50, height: 50 },
                                      ]}
                                      width={40}
                                      height={40}
                                      isResolveAsset
                                      source={{ uri: photo.url }}
                                    />
                                    <SociollaText style={styles.attachmentText}>
                                      {photo.name}
                                    </SociollaText>
                                  </View>
                                )}
                              </TouchableOpacity>
                              <SociollaText
                                style={{
                                  padding: 5,
                                  top: 70,
                                  position: 'absolute',
                                  color: Colors.red3,
                                  fontSize: 12,
                                  marginTop: 6,
                                }}>
                                {error}
                              </SociollaText>
                            </View>
                          </View>
                        </Layout.FormGroup>
                      </View>
                    </Layout.FormWrapper>
                  ) : (
                    false
                  )}
                  {page == 2 || isWeb ? (
                    <Layout.FormWrapper
                      style={{
                        paddingBottom: isAndroid
                          ? 220
                          : isIos
                          ? 170
                          : isMobileWeb
                          ? 190
                          : 0,
                      }}>
                      {isWeb ? (
                        <TitleSectionForm
                          title="Return Order Quantity"
                          showButton={false}
                        />
                      ) : (
                        false
                      )}
                      <View
                        style={{
                          width: '100%',
                          paddingHorizontal: isWeb ? 30 : 0,
                          ...(isWeb ? { paddingTop: 20 } : {}),
                        }}>
                        {products?.length ? (
                          (products || []).map((product, idx) => (
                            <TouchableOpacity
                              key={`product-${idx}`}
                              style={{
                                flexDirection: 'row',
                                borderBottomColor: Colors.grey0,
                                borderBottomWidth: 1,
                                paddingVertical: 17,
                                paddingHorizontal: 15,
                                maxWidth: isWeb ? '100%' : fullWidth,
                                backgroundColor: Colors.white,
                              }}>
                              <View style={{ marginRight: 6 }}>
                                <Image
                                  style={{
                                    width: imageSize,
                                    height: imageSize,
                                  }}
                                  width={imageSize}
                                  height={imageSize}
                                  compressWidth={imageSize}
                                  source={{ uri: product.combination.image }}
                                />
                              </View>
                              <View
                                style={{
                                  width: isWeb
                                    ? 'calc(100% - 45px)'
                                    : mobileWrapperWidth,
                                }}>
                                <View
                                  style={{
                                    flexDirection: 'row',
                                    justifyContent: 'space-between',
                                  }}>
                                  <SociollaText
                                    type="medium"
                                    numberOfLines={1}
                                    ellipsizeMode="tail"
                                    style={{
                                      maxWidth: isWeb
                                        ? 'calc(100% - 45px)'
                                        : mobileWidth,
                                      fontSize: 14,
                                    }}>
                                    {product?.combination?.reference
                                      ? `[${product.combination.reference}] `
                                      : product?.sku
                                      ? `[${product.sku}] `
                                      : ``}
                                    {product.name}
                                  </SociollaText>
                                </View>
                                <SociollaText
                                  style={{
                                    fontSize: 13,
                                    color: Colors.grey1,
                                    marginVertical: 10,
                                  }}>
                                  {product.brand && product.brand.name
                                    ? product.brand.name
                                    : '-'}
                                </SociollaText>

                                <View
                                  style={{
                                    flexDirection: 'row',
                                    justifyContent: 'space-between',
                                    alignItems: 'flex-end',
                                  }}>
                                  <View>
                                    <SociollaText
                                      style={{
                                        fontSize: 13,
                                        color: Colors.grey1,
                                      }}>
                                      NET Delivered{' '}
                                      {product.net_delivered_qty
                                        ? product.net_delivered_qty
                                        : 0}{' '}
                                      Pcs
                                    </SociollaText>
                                  </View>

                                  <View
                                    style={{
                                      flexDirection: 'column',
                                      alignItems: 'center',
                                    }}>
                                    {isEdit ? (
                                      tambah.status &&
                                      tambah.rowKey === product._id ? (
                                        <Input
                                          isNumeric={true}
                                          keyboardType={'numeric'}
                                          containerStyle={{
                                            width: isWeb ? '100%' : 60,
                                          }}
                                          value={products[idx].return_quantity}
                                          onChangeText={(text) => {
                                            const markers = [...products];
                                            markers[idx] = {
                                              ...markers[idx],
                                              return_quantity: text,
                                            };
                                            setProducts(markers);
                                          }}
                                        />
                                      ) : product.return_quantity > 0 ? (
                                        <Input
                                          isNumeric={true}
                                          keyboardType={'numeric'}
                                          containerStyle={{
                                            width: isWeb ? '100%' : 60,
                                          }}
                                          value={products[idx].return_quantity}
                                          onChangeText={(text) => {
                                            const markers = [...products];
                                            markers[idx] = {
                                              ...markers[idx],
                                              return_quantity: text,
                                            };
                                            setProducts(markers);
                                          }}
                                        />
                                      ) : (
                                        <Button
                                          type="default"
                                          rounded
                                          buttonStyle={{
                                            width: isWeb ? 150 : 85,
                                            marginRight: 0,
                                          }}
                                          title={
                                            <SociollaText
                                              type="bold"
                                              style={{
                                                fontSize: isWeb ? 14 : 13,
                                                letterSpacing: 0.5,
                                                color: Colors.black,
                                              }}>
                                              Add
                                            </SociollaText>
                                          }
                                          onPress={() => {
                                            if (product.net_delivered_qty > 0) {
                                              hideRow(product._id);
                                            } else {
                                              false;
                                            }
                                          }}
                                        />
                                      )
                                    ) : tambah.status &&
                                      tambah.rowKey === product._id ? (
                                      <Input
                                        isNumeric={true}
                                        keyboardType={'numeric'}
                                        containerStyle={{
                                          width: isWeb ? '100%' : 60,
                                        }}
                                        value={product.return_quantity}
                                        onChangeText={(text) => {
                                          const markers = [...products];
                                          markers[idx] = {
                                            ...markers[idx],
                                            return_quantity: text,
                                          };
                                          setProducts(markers);
                                        }}
                                      />
                                    ) : (
                                      <View>
                                        {product.return_quantity > 0 ? (
                                          <Input
                                            isNumeric={true}
                                            keyboardType={'numeric'}
                                            containerStyle={{
                                              width: isWeb ? '100%' : 60,
                                            }}
                                            value={product.return_quantity}
                                            onChangeText={(text) => {
                                              const markers = [...products];
                                              markers[idx] = {
                                                ...markers[idx],
                                                return_quantity: text,
                                              };
                                              setProducts(markers);
                                            }}
                                          />
                                        ) : (
                                          <Button
                                            type="default"
                                            rounded
                                            buttonStyle={{
                                              width: isWeb ? 150 : 85,
                                              marginRight: 0,
                                            }}
                                            title={
                                              <SociollaText
                                                type="bold"
                                                style={{
                                                  fontSize: isWeb ? 14 : 13,
                                                  letterSpacing: 0.5,
                                                  color: Colors.black,
                                                }}>
                                                Add
                                              </SociollaText>
                                            }
                                            onPress={() => {
                                              if (
                                                product.net_delivered_qty > 0
                                              ) {
                                                hideRow(product._id);
                                              } else {
                                                false;
                                              }
                                            }}
                                          />
                                        )}
                                      </View>
                                    )}
                                  </View>

                                  <View
                                    style={{
                                      flexDirection: 'row',
                                      alignItems: 'center',
                                    }}>
                                    {isEdit ? (
                                      <SociollaText style={{ fontSize: 14 }}>
                                        {currency(
                                          parseInt(
                                            products[idx].return_quantity,
                                          ) *
                                            (parseInt(
                                              products[idx]
                                                .total_price_before_tax,
                                            ) /
                                              parseInt(products[idx].quantity)),
                                          true,
                                        )}
                                        {calculateTotal()}
                                      </SociollaText>
                                    ) : (
                                      <SociollaText style={{ fontSize: 14 }}>
                                        {currency(
                                          parseInt(
                                            products[idx].return_quantity,
                                          ) *
                                            (parseInt(
                                              products[idx]
                                                .total_price_before_tax,
                                            ) /
                                              parseInt(products[idx].quantity)),
                                          true,
                                        )}
                                        {calculateTotal()}
                                      </SociollaText>
                                    )}
                                  </View>
                                </View>
                              </View>
                            </TouchableOpacity>
                          ))
                        ) : !loadingAddProduct ? (
                          <View
                            style={{
                              paddingVertical: 20,
                              justifyContent: 'center',
                              alignItems: 'center',
                            }}>
                            <Image
                              style={{ width: 30, height: 35 }}
                              width={30}
                              height={35}
                              source={require('@assets/img/icons/no-product.svg')}
                              svg={true}
                            />
                            <SociollaText style={{ marginVertical: 10 }}>
                              No product found
                            </SociollaText>
                          </View>
                        ) : (
                          false
                        )}
                        {skip <= products?.length &&
                        products?.length >= limit ? (
                          <View
                            style={{
                              width: '100%',
                              paddingVertical: 15,
                              alignItems: 'center',
                            }}>
                            <Button
                              rounded
                              buttonStyle={{
                                width: isWeb ? 150 : dimension.width - 30,
                              }}
                              title={
                                <SociollaText
                                  type="bold"
                                  style={{
                                    fontSize: 14,
                                    letterSpacing: 0.5,
                                    color: Colors.white,
                                  }}>
                                  Load More
                                </SociollaText>
                              }
                              onPress={() => {
                                getProductSalesOrder(
                                  isEdit
                                    ? detailData?._id
                                    : values?.source_order?.id ||
                                        props?.route?.params?.id,
                                  skip + limit,
                                  isEdit ? false : true,
                                );
                              }}
                            />
                          </View>
                        ) : (
                          false
                        )}
                      </View>

                      <Divider />
                      <View
                        style={{
                          width: '100%',
                          paddingVertical: 10,
                          paddingHorizontal: isWeb ? 40 : 15,
                          ...(isAndroid ? { marginBottom: 30 } : {}),
                        }}>
                        <ItemDetail
                          between={true}
                          name="Subtotal"
                          value={currency(subTotal, true)}
                        />
                        <ItemDetail
                          between={true}
                          name="Taxes"
                          value={currency(taxes, true)}
                        />
                        <ItemDetail
                          between={true}
                          name="TOTAL"
                          nameBold={true}
                          nameStyle={{ color: Colors.blue0 }}
                          value={currency(total, true)}
                          valueBold={true}
                          valueStyle={{ color: Colors.blue1 }}
                          withoutBorder={true}
                        />
                      </View>
                    </Layout.FormWrapper>
                  ) : (
                    false
                  )}
                </ScrollView>
              </Layout.Wrapper>
              {!isWeb && !isLoadingPage ? (
                <Layout.ButtonSticky
                  show={
                    props?.route?.name == 'ReturnOrderFormScreen' &&
                    [1, 2].includes(page)
                  }
                  route={props?.route}
                  buttons={
                    page == 1
                      ? [
                          {
                            title: 'Next',
                            onPress: () => setPage(2),
                            disabled:
                              values.upload_return_form?.length ||
                              Object.keys(detailData?.upload_return_form || {})
                                .length > 0
                                ? false
                                : true,
                          },
                        ]
                      : page == 2
                      ? [
                          {
                            title: 'Save',
                            onPress: (evt) => {
                              evt.persist();
                              if (!isEdit && products.length) {
                                setFieldValue('status', 'need_approval');
                              } else {
                                setFieldValue('status', 'draft');
                              }
                              setFieldValue('products', handleSave());
                              setTimeout(() => {
                                validateForm().then((validate) => {
                                  handleSubmit(evt);
                                  if (
                                    validate &&
                                    Object.keys(validate).length
                                  ) {
                                    setPage(1);
                                  }
                                });
                              }, 100);
                            },
                          },
                        ]
                      : []
                  }
                />
              ) : (
                false
              )}
            </>
          )}
        </Formik>
      )}
      <Alert />
      <Discard />
    </Layout.Container>
  );
};

const styles = StyleSheet.create({
  documentWrapper: {
    width: '100%',
    padding: 15,
    ...(!isWeb
      ? { borderBottomWidth: 1, borderBottomColor: Colors.grey0 }
      : {}),
  },
  attachment: {
    width: '100%',
    flexDirection: 'row',
    flexWrap: 'wrap',
    ...(!isWeb ? { justifyContent: 'space-between' } : {}),
  },
  attachmentItem: {
    width: isWeb ? 100 : '30%',
    justifyContent: 'center',
    alignItems: 'center',
    padding: 8,
    borderWidth: 1,
    borderColor: Colors.grey0,
    borderRadius: 4,
    marginRight: 10,
    marginBottom: 10,
  },
  attachmentIcon: {
    marginBottom: 10,
  },
  attachmentText: {
    fontSize: 13,
  },
});

export default ReturnOrderFormScreen;
